import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DelaStarIcon } from '~/modules/common/components';
import { useResourceMatchPopoverStyles } from './useStyles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(0.5)
  },
  delaText: {
    fontSize: theme.spacing(1.625),
    lineHeight: 1,
    color: theme.palette.Dela.darkIcon
  },
  spacerColumn: {
    width: theme.spacing(13.25)
  }
}));

export const useDelaStarIconStyles = makeStyles(theme => ({
  root: {
    fill: theme.palette.Dela.darkIcon,
    fontSize: theme.spacing(2.25)
  }
}));

export const ResourceMatchListHeader = ({ showActionColumn }) => {
  const classes = useStyles();
  const commonClasses = useResourceMatchPopoverStyles();
  const delaStarIconClasses = useDelaStarIconStyles();
  const { formatMessage } = useIntl();

  return (
    <div data-qe-id="ResourceMatchListHeader" className={classes.root}>
      <div className={commonClasses.resourceColumn}>
        <Typography variant="subtitle2" className={commonClasses.columnText}>
          {formatMessage({
            id: 'resourceMatchPopover.suggestedResource'
          })}
        </Typography>
      </div>
      <div className={commonClasses.smartMatchColumn}>
        <DelaStarIcon classes={delaStarIconClasses} />
        <Typography variant="subtitle2" className={commonClasses.columnText}>
          {formatMessage({
            id: 'resourceMatchPopover.confidence'
          })}
        </Typography>
      </div>
      <div className={commonClasses.availabilityColumn}>
        <Typography variant="subtitle2" className={commonClasses.columnText}>
          {formatMessage({
            id: 'resourceMatchPopover.availability'
          })}
        </Typography>
      </div>
      {showActionColumn && <div className={classes.spacerColumn}></div>}
    </div>
  );
};

ResourceMatchListHeader.propTypes = {
  showActionColumn: PropTypes.bool
};

export default ResourceMatchListHeader;
